import bridge from '../core/bridge';
import Other from '../platform/other';
import QQ from '../platform/qq';
import Qzone from '../platform/qzone';
import Weishi from '../platform/weishi';
import Weixin from '../platform/wx';

// eslint-disable-next-line import/prefer-default-export
export const WSBeacon = bridge({
  ws: Weishi,
  wx: Weixin,
  qq: QQ,
  qz: Qzone,
  other: Other,
});
